import { http } from "api/apiConfig";
import { WORK_ORDER_HISTORY } from "constants/endpoints";
export const fetchWorkOrderHistory = async (workOrderId) => {
    const { data } = await http.get(WORK_ORDER_HISTORY(workOrderId));
    return data;
};
